import { EnvironmentConfig } from "./environment-config";
function config(environmentName: string): EnvironmentConfig {
  const environment: EnvironmentConfig =
  {
    production: true,
    baseURL: `https://smartaltinn${environmentName}.holte.no`,
    apiUrl: `https://smartaltinnbackend${environmentName}.holte.no`,
    altinnBaseUrl: "https://tt02.altinn.no/",
    altinnInboxUrl: "https://af.tt02.altinn.no/",
    altinnApiKey: "F9BE960A-8DFC-4F31-B96C-EFAAE9FACE9E",
    oidc: {
      authority: "https://test.idporten.no",
      clientId: environmentName == "victor" ? "77c34c9f-3150-401f-a475-db4967c46076" : (environmentName == "oscar" ? "ecb0316c-7864-470d-a879-13723d487dae" : "e63a243a-730d-4cc1-9034-01568ca42113"),
    },
    name: environmentName
  };

  return environment;
}

export default config;
